import dayjs from 'dayjs';
import { pick, kebabCase, cloneDeep } from 'lodash';
import numberUtils from '@/utils/number-format-utils';
import { useInternationalization } from '@/composables/use-internationalization';

export function useExportCsv() {
  const { t } = useInternationalization();
  // Function that returns file name for the future csv.
  const getFileName = ({ serviceName, workpackageName, scenarioName, fileNameDateFormat }) => {
    const date = dayjs().format(fileNameDateFormat);
    const fileServiceName = t(`csvExport.services.${serviceName}`);

    let fileName = `${date}-${fileServiceName}`;

    if (workpackageName) {
      fileName += `-${kebabCase(workpackageName)}`;
    }
    if (scenarioName) {
      fileName += `-${kebabCase(scenarioName)}`;
    }

    fileName += '.csv';

    return fileName;
  };

  // Function that transforms ag-grid table row to list of translated fields with their values.
  const extractAndTranslateValues = ({
    row,
    delimiter,
    keysToExport,
    booleanFields = [],
    numericFields = [],
  }) => {
    // Only pick fields that are defined in the schema
    const requiredData = cloneDeep(pick(row, keysToExport));

    // Translate boolean values
    booleanFields.forEach(({ mongoField }) => {
      requiredData[mongoField] = t(`csvExport.valueTranslations.${requiredData[mongoField]}`);
    });

    numericFields.forEach(({ mongoField }) => {
      requiredData[mongoField] = numberUtils.formatNumberIfNumeric({
        value: requiredData[mongoField],
        format: 'export',
      });
    });

    return Object.values(requiredData).join(delimiter);
  };

  return {
    getFileName,
    extractAndTranslateValues,
  };
}
